import { Box, styled, Typography } from '@mui/material';

export const BoxStyled = styled(Box)(({ theme }) => ({
  margin: '16px 0',
  padding: '16px ',
  borderRadius: theme.spacing(0.5),
  backgroundColor: theme.palette.colors.selectedAndDetailBackground,
  [theme.breakpoints.up('lg')]: {
    width: '439px',
  },
}));

export const TypographyTitleStyled = styled(Typography)(({ theme }) => ({
  width: '100%',
  margin: '0 38px 3px 0',
  fontSize: '20px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));
